<template>
  <rect width="11" height="1" transform="matrix(1 0 0 -1 2 13)" fill="#A6A6A6" />
  <rect width="1" height="2" transform="matrix(1 0 0 -1 7 11)" fill="#A6A6A6" />
  <rect width="1" height="2" transform="matrix(1 0 0 -1 7 8)" fill="#A6A6A6" />
  <rect width="1" height="2" transform="matrix(1 0 0 -1 7 5)" fill="#A6A6A6" />
</template>
